/**
 * The free/Plus line, in one place. Price is a placeholder — nothing charges
 * anything yet, since no billing provider is wired up. Whatever number ends
 * up here just needs to change, not the shape of anything that reads it.
 */
export const SONGWRITER_PLANS = [
  {
    id: 'free',
    label: 'Free',
    price: 'Free',
    blurb: 'Write, sign, and send songs to your church.',
    features: [
      'Unlimited drafts',
      'Send finished songs to your church',
      'Reach up to your church',
    ],
  },
  {
    id: 'plus',
    label: 'Plus',
    price: 'TBD',
    blurb: 'Open your songs past your own church, and get help getting them out further.',
    features: [
      'Open a song to Collective feedback',
      'Let other churches request to cover a song',
      'Reach your writers’ Circles and The Collective',
      'Request Beseter/SPM handle your publishing registration',
      'Request distribution assistance for a song',
    ],
  },
]

export const CHURCH_PLANS = [
  {
    id: 'free',
    label: 'Free',
    price: 'Free',
    blurb: 'Review what your writers send you.',
    features: [
      'Unlimited approved writers',
      'Full review workflow',
    ],
  },
  {
    id: 'plus',
    label: 'Plus',
    price: 'TBD',
    blurb: 'More room, and priority when something needs a hand.',
    features: [
      'Priority support',
      'Early access to new review tools',
    ],
  },
]
